/* DECO SUITE — reveals al scroll + calculadora de m² */
(function () {
  'use strict';

  /* ---------- Revelado al scroll ---------- */
  function initReveals(root) {
    var nodes = (root || document).querySelectorAll('.deco-reveal:not(.is-visible)');
    if (!nodes.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---------- Calculadora de m² ----------
     Entrada: m² de pared.
     Salida: azulejos y cajas necesarias con +10 % de margen de corte. */
  function initCalculators(root) {
    (root || document).querySelectorAll('[data-deco-calc]:not([data-deco-init])').forEach(function (calc) {
      calc.setAttribute('data-deco-init', '1');
      var input = calc.querySelector('[data-calc-input]');
      var button = calc.querySelector('[data-calc-button]');
      var result = calc.querySelector('[data-calc-result]');
      var error = calc.querySelector('[data-calc-error]');
      var tileW = parseFloat(calc.dataset.tileWidth) || 29.8;   /* cm */
      var tileH = parseFloat(calc.dataset.tileHeight) || 7.8;   /* cm */
      var perBox = parseInt(calc.dataset.tilesPerBox, 10) || 30;
      var margin = 1 + (parseFloat(calc.dataset.margin) || 10) / 100;
      var tileArea = (tileW / 100) * (tileH / 100); /* m² por azulejo */

      function compute() {
        var m2 = parseFloat(String(input.value).replace(',', '.'));
        if (!isFinite(m2) || m2 <= 0 || m2 > 10000) {
          result.classList.remove('is-visible');
          error.classList.add('is-visible');
          return;
        }
        error.classList.remove('is-visible');
        var m2WithMargin = m2 * margin;
        var tiles = Math.ceil(m2WithMargin / tileArea);
        var boxes = Math.ceil(tiles / perBox);
        calc.querySelector('[data-calc-tiles]').textContent = tiles.toLocaleString('es-ES');
        calc.querySelector('[data-calc-boxes]').textContent = boxes.toLocaleString('es-ES');
        calc.querySelector('[data-calc-m2]').textContent = m2.toLocaleString('es-ES', { maximumFractionDigits: 2 });
        calc.querySelector('[data-calc-m2margin]').textContent = m2WithMargin.toLocaleString('es-ES', { maximumFractionDigits: 2 });
        result.classList.add('is-visible');
      }

      button.addEventListener('click', function (e) { e.preventDefault(); compute(); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); compute(); }
      });
    });
  }

  /* ---------- CTA de muestra: selecciona la variante Muestra ---------- */
  function initSampleCtas(root) {
    (root || document).querySelectorAll('[data-deco-sample-cta]:not([data-deco-init])').forEach(function (cta) {
      cta.setAttribute('data-deco-init', '1');
      var btn = cta.querySelector('[data-sample-select]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        var url = btn.getAttribute('data-sample-url');
        if (url) {
          e.preventDefault();
          window.location.href = url;
        }
      });
    });
  }

  function initAll(root) {
    initReveals(root);
    initCalculators(root);
    initSampleCtas(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();